export default "__VITE_ASSET__0PW51oTp__"